export default {
  loading: 'Chargement de la consommation...',
  errorTitle: 'Consommation Introuvable',
  notFound: 'La consommation demandée n\'a pas pu être trouvée',
  fetchError: 'Échec du chargement de la consommation',
  consumptionDetails: 'Détails de la Consommation',
  unitsConsumed: 'unités consommées',
  resource: 'Ressource',
  consumer: 'Consommateur',
  quantityConsumed: 'Quantité Consommée',
  consumedAt: 'Consommé le',
  notes: 'Notes'
};
